import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';

import { Drawer, drawerType } from '../../../../../packages/ui/organisms/drawer';

import { showSnackbar } from '../../../../../redux/modules/snackbar';
import { addNewService, deleteService, updateService } from '../../../../../services/member/member.service';
import { scheduleActionCreators } from '../../../../../redux/modules/schedule';

import ServiceItem from './service-item';
import AddService from './add-service';
import { useStyles } from './Services.styles';
import { profileActionCreators } from '../../../../../redux/modules/profile';

const EditServices = ({ isOpen, providerId, onClose, services }) => {
  const classes = useStyles();
  const [editService, setEditService] = useState(null);
  const [showAddService, setShowAddService] = useState(false);
  const dispatch = useDispatch();

  const onCloseEdit = () => {
    setEditService(null);
    setShowAddService(false);
  };

  const onEditService = service => {
    setEditService(service);
  };

  const toggleService = async service => {
    try {
      await updateService(service.id, {
        ...service,
        providerId,
        buffer: service?.bufferTime,
        active: !service.serviceAvailable,
      });
      dispatch(
        showSnackbar({
          snackType: 'success',
          snackMessage: 'Service updated successfully',
        }),
      );
      dispatch(scheduleActionCreators.fetchProviderServices(providerId));
      dispatch(profileActionCreators.fetchProviderDetails(providerId));
    } catch (error) {
      dispatch(
        showSnackbar({
          snackType: 'error',
          snackMessage: error.data?.errors?.[0]?.endUserMessage || 'Can not update service!',
        }),
      );
    }
  };

  const onDeleteService = async () => {
    try {
      await deleteService(editService.id, providerId);
      dispatch(
        showSnackbar({
          snackType: 'success',
          snackMessage: 'Service deleted successfully',
        }),
      );
      dispatch(scheduleActionCreators.fetchProviderServices(providerId));
      dispatch(profileActionCreators.fetchProviderDetails(providerId));
      onCloseEdit();
    } catch (error) {
      dispatch(
        showSnackbar({
          snackType: 'error',
          snackMessage: error.data?.errors?.[0]?.endUserMessage || 'Can not delete service!',
        }),
      );
    }
  };

  const onUpdateService = async service => {
    const serviceMerged = {
      ...editService,
      ...service,
      buffer: service?.bufferTime,
      providerId,
      active: editService.serviceAvailable,
      serviceId: editService.id,
      serviceTypes: service.serviceTypes,
    };
    try {
      await updateService(editService.id, serviceMerged);
      dispatch(
        showSnackbar({
          snackType: 'success',
          snackMessage: 'Service updated successfully',
        }),
      );
      dispatch(scheduleActionCreators.fetchProviderServices(providerId));
      dispatch(profileActionCreators.fetchProviderDetails(providerId));
      onCloseEdit();
    } catch (error) {
      dispatch(
        showSnackbar({
          snackType: 'error',
          snackMessage: error.data?.errors?.[0]?.endUserMessage || 'Can not update service!',
        }),
      );
    }
  };

  const onAddNewService = async service => {
    const payload = {
      buffer: service.bufferTime,
      providerId,
      cost: service.cost,
      description: service.description,
      duration: service.duration,
      marketCost: service.marketCost,
      name: service.name,
      privateService: service.privateService,
      initialService: service.initialService,
      recommendedCost: service.recommendedCost,
      requireSupervisorSignOff: service.requireSupervisorSignOff,
      serviceTypes: service.serviceTypes,
      providerFee: service.providerFee,
      defaultFollowUp: service.defaultFollowUp,
      defaultInitial: service.defaultInitial,
      cashRate: service.cashRate,
    };
    try {
      await addNewService(payload);
      dispatch(scheduleActionCreators.fetchProviderServices(providerId));
      dispatch(profileActionCreators.fetchProviderDetails(providerId));
      dispatch(
        showSnackbar({
          snackType: 'success',
          snackMessage: 'New service added successfully',
        }),
      );
      onCloseEdit();
    } catch (error) {
      dispatch(
        showSnackbar({
          snackType: 'error',
          snackMessage: error.data.errors?.[0]?.endUserMessage || 'Can not create service!',
        }),
      );
    }
  };

  const onClickAddService = () => {
    setShowAddService(true);
  };

  return (
    <>
      <Drawer
        title="Edit services"
        open={isOpen}
        onClose={onClose}
        variant={drawerType.FORM}
        submitBtnTitle="Add service"
        onSubmit={onClickAddService}
      >
        <Box className={classes.drawerContent}>
          {services?.map(service => (
            <ServiceItem
              key={service.id}
              service={service}
              isEditable
              onEditService={onEditService}
              toggleService={toggleService}
            />
          ))}
        </Box>
      </Drawer>
      <AddService
        isOpen={!!editService || showAddService}
        onClose={onCloseEdit}
        isEdit={!!editService}
        service={editService}
        onDeleteService={onDeleteService}
        onUpdateService={onUpdateService}
        onAddService={onAddNewService}
      />
    </>
  );
};

export { EditServices };
